document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-bank10-copy]');
  if (!button) return;
  const code = button.dataset.code;
  if (!code) return;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(code);
    } else {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      const copied = document.execCommand('copy');
      field.remove();
      if (!copied) throw new Error('Copy unavailable');
    }
    button.textContent = 'Copied';
    button.classList.add('is-copied');
    button.setAttribute('aria-label', 'BANK10 code copied');
    clearTimeout(button._bank10Timer);
    button._bank10Timer = setTimeout(function () {
      button.textContent = 'Copy';
      button.classList.remove('is-copied');
      button.setAttribute('aria-label', 'Copy discount code BANK10');
    }, 2500);
  } catch (error) {
    button.textContent = 'Select code';
    button.setAttribute('aria-label', 'Select BANK10 code shown beside this button');
  }
});
